var __hasOwnProperty = Object.prototype.hasOwnProperty;
var __getOwnPropertySymbols = Object.getOwnPropertySymbols;
var __propertyIsEnumerable = Object.prototype.propertyIsEnumerable;
var __rest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProperty.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropertySymbols) {
    for (var prop of __getOwnPropertySymbols(source))
      if (exclude.indexOf(prop) < 0 && __propertyIsEnumerable.call(source, prop))
        target[prop] = source[prop];
  }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (result) => {
      return result.done ? resolve(result.value) : Promise.resolve(result.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import Vue from "vue";
export default function createDialog(component) {
  let rootVm = null;
  component.open = (data = {}) => {
    const {on, onOk, onCancel, afterClose, parent, router, ref} = data, other = __rest(data, ["on", "onOk", "onCancel", "afterClose", "parent", "router", "ref"]);
    const VueComponent = Vue.extend(component);
    let dialogVm = new VueComponent({
      parent,
      router,
      propsData: other
    });
    rootVm = dialogVm;
    if (on) {
      Object.keys(on).forEach((key) => {
        rootVm.$on(key, on[key]);
      });
    }
    rootVm.$mount();
    if (ref) {
      ref.vm = rootVm;
    }
    if (component.name !== "g-dialog") {
      const vm = rootVm.$children[0];
      if (vm.$options.name === "g-dialog") {
        dialogVm = vm;
      } else {
        throw new Error("根组件必须是dialog");
      }
    }
    dialogVm.innerVisible = true;
    let done = false;
    rootVm.update = (data2 = {}) => {
      Object.assign(rootVm, data2);
    };
    return new Promise((resolve) => {
      rootVm.$close = () => {
        dialogVm.innerVisible = false;
        resolve(false);
      };
      rootVm.$onOk = (data2) => __async(this, null, function* () {
        if (onOk) {
          const res = yield onOk(data2);
          if (res === false)
            return;
        }
        done = true;
        dialogVm.innerVisible = false;
        resolve(data2 || true);
      });
      rootVm.$onCancel = () => __async(this, null, function* () {
        if (onCancel) {
          const res = yield onCancel();
          if (res === false)
            return;
        }
        done = true;
        dialogVm.innerVisible = false;
        resolve(false);
      });
      if (dialogVm !== rootVm) {
        dialogVm.$close = () => __async(this, null, function* () {
          rootVm.$close();
        });
        dialogVm.$onOk = (data2) => __async(this, null, function* () {
          rootVm.$onOk(data2);
        });
        dialogVm.$onCancel = () => __async(this, null, function* () {
          rootVm.$onCancel();
        });
        dialogVm.$afterClose = () => {
          if (afterClose)
            afterClose();
          if (done)
            rootVm.$destroy();
        };
      }
    }).then((v) => {
      if (!dialogVm.innerVisible)
        rootVm.$destroy();
      dialogVm.innerVisible = false;
      return v;
    });
  };
  component.close = () => {
    rootVm && rootVm.$close();
  };
  return component;
}
